import ReactGA from 'react-ga4';
import config from '../app.json';

const trackingId = config.firebaseConfig.measurementId;

ReactGA.initialize(trackingId);

export const trackPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

const checkGoogleAnalytics = () => {
  return config.GOOGLE_ANALYTICS && config.GOOGLE_ANALYTICS.length;
};

export const setupAnalytics = () => {
  if (!checkGoogleAnalytics()) {
    return;
  }

  ReactGA.initialize(config.GOOGLE_ANALYTICS);

  ReactGA.send({
    hitType: 'pageview',
    page: window.location.pathname + window.location.search,
  });
};

export const loginSuccesstrackGoogle = async () => {
  function track() {
    if (!checkGoogleAnalytics()) {
      return;
    }
    ReactGA.event({
      category: 'signin',
      action: 'signin_success',
      label: 'google',
    });
  }
  track();
};

export const signUpSuccesstrackGoogle = async (viaGoogle) => {
  function track() {
    if (!checkGoogleAnalytics()) {
      return;
    }
    ReactGA.event({
      category: 'signup',
      action: 'signup_success',
      label: viaGoogle ? 'google' : 'native',
    });
  }
  track();
};

export const trackGooglePurchaseSuccess = async (purchaseData) => {
  function track() {
    if (!checkGoogleAnalytics()) {
      return;
    }

    ReactGA.event('purchase', purchaseData);
  }

  track();
};
